"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var storyHasImagesUnderModeration = function (story) {
    return !!(story === null || story === void 0 ? void 0 : story.imagesUnderModeration);
};
exports.default = storyHasImagesUnderModeration;
